import { render } from "./button.html?vue&type=template&id=c83f01de&scoped=true&ts=true&external"
import script from "./button.ts?vue&type=script&lang=ts&external"
export * from "./button.ts?vue&type=script&lang=ts&external"

import "./button.scss?vue&type=style&index=0&id=c83f01de&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83f01de"]])

export default __exports__